function CtxSwitcherAnimation($timeout) {
    return {
        enter: function (element, done) {
            $timeout(function () {
                let height = element[0] ? Math.round(element[0].getBoundingClientRect().height) : 0,
                    parentEl = element.closest('ctx-content-switcher'),
                    switcherEl = parentEl.find('.ctx-content-switcher');

                switcherEl.animate({ height: height + "px" }, 0, () => {
                    if (parentEl[0].hasAttribute('switcher-auto-height')) {
                        $timeout(() => { switcherEl.css({ height: "auto" }); }, 0)
                    }
                });
                done();
            }, 0);
        },
        leave: function (element, done) {
            done();
        }
    };
}

module.exports = CtxSwitcherAnimation;




// WEBPACK FOOTER //
// ./src/shared/ctxContentSwitcher/ctxSwitcher.animation.js